(() => {
  // app/scripts/product-gallery.js
  !window.customElements.get("product-gallery") && window.customElements.define("product-gallery", class extends HTMLElement {
    constructor() {
      super();
      this.mainGallery = this.querySelector(".product-main-media");
      this.isZoomIn = false;
    }
    connectedCallback() {
      this.setupEventListeners();
    }
    setupEventListeners() {
      const mediaImages = this.mainGallery.querySelectorAll(".media-type-image");
      if (mediaImages.length > 0) {
        mediaImages.forEach((media) => {
          media.addEventListener("click", (e) => this.toggleZoom(e));
        });
      }
    }
    toggleZoom(e) {
      e.preventDefault();
      const target = e.target;
      this.mainGallery.classList.toggle("zoom-in");
      const rect = target.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const xPercent = x / rect.width * 100;
      const yPercent = y / rect.height * 100;
      target.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      if (this.isZoomIn) {
        this.isZoomIn = false;
        target.style.transform = `scale(1,1)`;
      } else {
        this.isZoomIn = true;
        target.style.transform = `scale(2,2)`;
        this.initZoom(target);
      }
    }
    initZoom(el) {
      el.addEventListener("mousemove", (evt) => this.handleZoomMouseMove(evt));
      el.addEventListener("touchmove", (evt) => this.handleZoomMouseMove(evt));
    }
    handleZoomMouseMove(evt) {
      if (!this.isZoomIn)
        return;
      const zoomImage = evt.target;
      const zoomWrap = zoomImage.closest("div");
      try {
        const rect = zoomWrap.getBoundingClientRect();
        const offsetX = evt.clientX ? evt.clientX - rect.left : evt.touches[0].clientX - rect.left;
        const offsetY = evt.clientY ? evt.clientY - rect.top : evt.touches[0].clientY - rect.top;
        const x = offsetX / zoomImage.offsetWidth * 100;
        const y = offsetY / zoomImage.offsetHeight * 100;
        zoomImage.style.transformOrigin = `${x}% ${y}%`;
      } catch (err) {
        console.error("Zoom error:", err);
      }
    }
  });
})();
